import { AstNodeCategory, AstNodeType } from './node';
export class IndexExpression {
    constructor(token, left, index) {
        this.token = token;
        this.left = left;
        this.index = index;
        this.nodeType = AstNodeType.IndexExpression;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Left() {
        return this.left;
    }
    set Left(val) {
        this.left = val;
    }
    get Index() {
        return this.index;
    }
    set Index(val) {
        this.index = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return `(${this.left.toString()}[${this
            .index.toString()}])`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZXhFeHByZXNzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvSW5kZXhFeHByZXNzaW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFjLE1BQU0sUUFBUSxDQUFDO0FBRWxFLE1BQU0sT0FBTyxlQUFlO0lBQ3hCLFlBQ1ksS0FBWSxFQUNaLElBQWlCLEVBQ2pCLEtBQWtCO1FBRmxCLFVBQUssR0FBTCxLQUFLLENBQU87UUFDWixTQUFJLEdBQUosSUFBSSxDQUFhO1FBQ2pCLFVBQUssR0FBTCxLQUFLLENBQWE7UUFHOUIsYUFBUSxHQUFnQixXQUFXLENBQUMsZUFBZSxDQUFDO1FBQ3BELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxVQUFVLENBQUM7SUFIeEQsQ0FBQztJQUtKLElBQUksSUFBSTtRQUNKLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQztJQUNyQixDQUFDO0lBRUQsSUFBSSxJQUFJLENBQUMsR0FBRztRQUNSLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFFRCxJQUFJLEtBQUs7UUFDTCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDdEIsQ0FBQztJQUVELElBQUksS0FBSyxDQUFDLEdBQUc7UUFDVCxJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQztJQUNyQixDQUFDO0lBRUQsWUFBWTtRQUNSLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztJQUVELFFBQVE7UUFDSixPQUFPLElBQUssSUFBSSxDQUFDLElBQW1CLENBQUMsUUFBUSxFQUFFLElBQUssSUFBSTthQUNuRCxLQUFvQixDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUM7SUFDN0MsQ0FBQztDQUNKIn0=